import axios from '@/server/request'
import { Message } from 'element-ui'

const getSessionData = name => JSON.parse(sessionStorage.getItem(name))
const getLocalData = name => JSON.parse(localStorage.getItem(name))
let h5PathStrore = ''
if (localStorage.getItem('yt_h5_path') && localStorage.getItem('yt_h5_path') !== undefined) {
    h5PathStrore = JSON.parse(localStorage.getItem('yt_h5_path'))
}

const state = {
    // 城市全部数据
    cityData: [],

    // 推荐城市列表
    recommendCity: [],

    // 当前选择城市列表 by 政策
    cityOfPolicy: [],

    // 当前选择城市列表 by 实时热点
    cityOfHot: [],

    // 当前搜索类型, 'article': 搜文章, 'account': 搜账号
    searchType: 'article',

    // 搜索关键词
    searchKeyword: '',

    // 用户信息
    userInfo: {},

    // 当前页面激活路由
    activeRoute: '',

    // 上一个页面跑由
    deactiveRoute: '',

    // 素材分类列表
    materialTypeList: [],

    // 用户权限
    powersign: sessionStorage.getItem('powersign') || 0,

    // 是否触发VIP剩余天数判断提示
    triggerVipValidate: false,

    // 公众号对比已添加信息列表
    accountDiffOptions: [],

    // 从 H5 跳转过来的地址
    h5Path: h5PathStrore,

    // 未授权用户浏览时弹出的登录提示类型，空字符串为不显示, '' | 'login' | 'register' | 'forget'
    authDialogType: ''
}

const getters = {
    cityData: state => {
        if (state.cityData.length > 0) {
            return state.cityData
        } else {
            return getSessionData('yt_cities') || []
        }
    },

    recommendCities: state => {
        if (state.cityData.length > 0) {
            return state.recommendCity
        } else {
            return getSessionData('yt_recommend_cities') || []
        }
    },
    materialTypeList: state => {
        if (state.materialTypeList.length > 0) {
            return state.materialTypeList
        } else {
            return getSessionData('yt_material-type_list') || []
        }
    },

    userInfo: state => {
        if (state.userInfo && state.userInfo.aInfoData) {
            return state.userInfo
        } else {
            return getLocalData('yt_user') || {}
        }
    },

    citiesOfPolicy: state => {
        if (state.cityOfPolicy.length > 0) {
            return state.cityOfPolicy
        } else {
            return getLocalData('yt_city-of-policy') || []
        }
    },
    citiesOfHot: state => {
        if (state.cityOfHot.length > 0) {
            return state.cityOfHot
        } else {
            return getLocalData('yt_city-of-hot') || []
        }
    },
    activeRoute: state => state.activeRoute,
    deactiveRoute: state => {
        if (state.deactiveRoute === '/') {
            return getSessionData('yt_last_path')
        } else {
            return state.deactiveRoute
        }
    }
}

const mutations = {
    updatePolicyCity(state, payload) {
        state.cityOfPolicy = payload
        localStorage.setItem('yt_city-of-policy', JSON.stringify(payload))
    },

    updateHotCity(state, payload) {
        state.cityOfHot = payload
        localStorage.setItem('yt_city-of-hot', JSON.stringify(payload))
    },

    updateSearchType(state, payload) {
        state.searchType = payload
    },

    updateSearchKeyword(state, payload) {
        state.searchKeyword = payload
    },

    updateActiveRoute(state, payload) {
        state.activeRoute = payload
    },

    updateDeactiveRoute(state, payload) {
        state.deactiveRoute = payload
        sessionStorage.setItem('yt_last_path', JSON.stringify(payload))
    },

    updateCityData(state, payload) {
        state.cityData.splice(0)
        state.cityData = payload
    },

    updateRecommendCity(state, payload) {
        state.recommendCity = payload
    },

    updateUserInfo(state, payload) {
        state.userInfo = null
        state.userInfo = payload
    },

    updateMaterialTypeList(state, payload) {
        state.materialTypeList = payload
    },

    setPowerSign(state, powersign) {
        // 设置是否大屏
        state.powersign = powersign
    },

    updateTriggerVipValidate(state, payload) {
        state.triggerVipValidate = payload
    },

    updateAccountDiff(state, payload) {
        state.accountDiffOptions = payload
    },

    updateH5Path(state, payload) {
        state.h5Path = payload
        localStorage.setItem('yt_h5_path', JSON.stringify(payload))
    },

    updateAuthDialogType(state, payload) {
        state.authDialogType = payload
    }
}

const actions = {
    // 用户登录
    async userLogin({ commit }, params) {
        try {
            const res = await axios.post({
                url: '/index/login',
                params
            })
            if (res.data.ErrorCode === 200) {
                localStorage.setItem('yt-dc-token', res.data.Data.sToken)
                sessionStorage.setItem('powersign', res.data.Data.iScreenUser)
            }
            return res
        } catch (errMsg) {
            console.log(errMsg)
        }
    },

    // 用户退出
    async logout({ commit }) {
        try {
            // const res = await axios.get({
            //     url: '/index/logout'
            // })
            // if (res.data.ErrorCode === 200) {
            //     commit('updateUserInfo', null)
            //     localStorage.removeItem('yt_user')
            //     // getLocalData.setItem('yt_user', null)
            // }

            commit('updateUserInfo', null)
            localStorage.removeItem('yt_user');
            // return res
        } catch (errMsg) {
            console.log(errMsg)
        }
    },

    // 获取用户信息
    async fetchUserInfo({ commit }) {
        try {
            const res = await axios.get({
                url: '/user/info'
            })

            if (res.data.ErrorCode === 200) {
                commit('updateUserInfo', res.data.Data)
                localStorage.setItem('yt_user', JSON.stringify(res.data.Data))


                if (res.data.Data.aAttentionCity && res.data.Data.aAttentionCity.aCityHot.length) {
                    localStorage.setItem('yt_city-of-hot', JSON.stringify(res.data.Data.aAttentionCity.aCityHot))
                }
                if (res.data.Data.aAttentionCity && res.data.Data.aAttentionCity.aCityPolicy.length) {
                    localStorage.setItem('yt_city-of-policy', JSON.stringify(res.data.Data.aAttentionCity.aCityPolicy))
                }

                return  res;

            }
        } catch (errMsg) {
            console.log(errMsg)
        }
    },

    // 获取按拼音排序的城市数据
    async fetchCities({ commit }) {
        try {
            const res = await axios.get({
                url: '/common/getCityByPinyin'
            })

            if (res.data.ErrorCode === 200) {
                const cities = res.data.Data.filter(city => +city.isShow === 1)

                commit('updateCityData', res.data.Data)
                commit('updateRecommendCity', cities)
                sessionStorage.setItem('yt_cities', JSON.stringify(res.data.Data))
                sessionStorage.setItem('yt_recommend_cities', JSON.stringify(cities))
            }
        } catch (errMsg) {
            console.log(errMsg)
        }
    },

    // 添加订阅
    async subscribe({ dispatch }, params) {
        let tips = '订阅成功'
        if (params.tips) {
            tips = params.tips
            delete params.tips
        }

        try {
            const res = await axios.post({
                url: '/subscribe/save',
                params
            })

            if (res.data.ErrorCode === 200) {
                dispatch('fetchUserInfo')
                Message({
                    message: tips,
                    type: 'success'
                })
                return Promise.resolve(tips)
            } else {
                Message({
                    message: res.data.ErrorMessage,
                    type: 'warning'
                })
                return Promise.reject(res.data.ErrorMessage)
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    // 取消订阅
    async unsubscribe({ dispatch }, params) {
        try {
            const res = await axios.post({
                url: '/subscribe/deletePlan',
                params
            })

            if (res.data.ErrorCode === 200) {
                dispatch('fetchUserInfo')
                Message({
                    message: '取消订阅成功',
                    type: 'success'
                })
                return Promise.resolve('取消订阅成功')
            } else {
                Message({
                    message: res.data.ErrorMessage,
                    type: 'warning'
                })
                return Promise.reject(res.data.ErrorMessage)
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    // 添加对比
    async contrast({ state, dispatch }, params) {
        if (state.accountDiffOptions.length === 5) {
            Message({
                message: '最多添加5个公众号对比',
                type: 'warning'
            })
            return Promise.reject(new Error())
        }

        try {
            const res = await axios.post({
                url: '/wechatcompare/add',
                params
            })

            if (res.data.ErrorCode === 200) {
                Message({
                    message: '账号对比添加成功',
                    type: 'success'
                })
                dispatch('fetchAccountDiff')
                return Promise.resolve('账号对比添加成功')
            } else {
                Message({
                    message: res.data.ErrorMessage,
                    type: 'warning'
                })
                return Promise.reject(res.data.ErrorMessage)
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    // 取消对比
    async unContrast({ dispatch }, params) {
        try {
            const res = await axios.post({
                url: '/wechatcompare/del',
                params
            })

            if (res.data.ErrorCode === 200) {
                Message({
                    message: '取消对比成功',
                    type: 'success'
                })
                dispatch('fetchAccountDiff')
                return Promise.resolve('取消对比成功')
            } else {
                Message({
                    message: res.data.ErrorMessage,
                    type: 'warning'
                })
                return Promise.reject(res.data.ErrorMessage)
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    // 获取素材类型列表
    async material({ commit }, params) {
        try {
            const res = await axios.post({
                url: '/materialcategory/list',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateMaterialTypeList', res.data.Data)
                sessionStorage.setItem('yt_material-type_list', JSON.stringify(res.data.Data))
            } else {
                Message({
                    message: res.data.ErrorMessage,
                    type: 'warning'
                })
                return Promise.reject(res.data.ErrorMessage)
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    // 添加到素材库
    async addMaterial({ commit }, params) {
        try {
            const res = await axios.post({
                url: '/material/addMaterial',
                params
            })

            if (res.data.ErrorCode === 200) {
                Message({
                    message: '素材添加成功',
                    type: 'success'
                })
                return Promise.resolve('素材添加成功')
            } else {
                Message({
                    message: res.data.ErrorMessage,
                    type: 'warning'
                })
                return Promise.reject(res.data.ErrorMessage)
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    setPowerSign({ commit }, powersign) {
        // 设置大屏
        commit('setPowerSign', powersign)
    },

    // 获取公众号已添加未对比数量
    async fetchAccountDiff({ commit }, params) {
        try {
            const res = await axios.get({
                url: '/wechatcompare/accountlist'
            })

            if (res.data.ErrorCode === 200) {
                commit('updateAccountDiff', res.data.Data)
            }
        } catch (errMsg) {
            console.log(errMsg)
        }
    },

    // 获取相似文章数据
    async getSimilarArticleList(context, params) {
        try {
            const res = await axios.get({
                url: '/search/getSimArticle',
                params
            })

            if (res.data.ErrorCode === 200) {
                return Promise.resolve(res.data.Data)
            } else {
                return Promise.reject(res.data.ErrorMessage)
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
